import styled from 'styled-components/macro'
import { FlexAlign } from '../../Flex'

export const FlexButtonGroupDiv = styled.div<{
  num: number
  $align?: FlexAlign
}>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.num}, max-content);
  gap: 12px;
  align-items: ${({ $align }) => ($align ? $align : FlexAlign.CENTER)};
`
